// // src/App.js

// import React from "react";
// import { Route, Routes, Navigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { useEffect } from "react";
// import { fetchAlertsByUser } from "./redux/slices/AlertSlice";
// // import { fetchCurrentUser } from "./redux/slices/authSlice";


// // Components
// import Login from "./components/Login";
// import Dashboard from "./components/User/Dashboard";
// import AdminPage from "./components/Admin/adminpage";
// import AddUser from "./components/Admin/AddUser";
// import AddDevice from "./components/Admin/AddDevice";
// import AddAdmin from "./components/Admin/AddAdmin";
// import AssignUser from "./components/Admin/AssignUser";
// import AddPatient from "./components/Admin/AddPatient";
// import AssignDevice from "./components/Admin/AssignDevice";
// import PatientVitalsPage from "./components/Admin/PatientVitalsPage";
// import ProtectedRoute from "./components/User/ProtectedRoute";
// import AlertsPage from "./components/User/useralerts";
// import PatientList from "./components/User/PatientList";

// function App() {
//   const { user } = useSelector((state) => state.auth);
//   const dispatch = useDispatch();
  


//   useEffect(() => {
//     if (user && user.user_id && user.role === "user") {
//       // Only fetch alerts by user if the logged-in user is non-admin user
//       dispatch(fetchAlertsByUser(user.user_id));


//       const interval = setInterval(() => {
//         dispatch(fetchAlertsByUser(user.user_id));
//       }, 5000);


//       return () => clearInterval(interval);
//     }
//   }, [dispatch, user]);

//   return (
//     <Routes>
//       {/* Login Route */}
//       <Route path="/login" element={<Login />} />

//       {/* Admin Protected Routes */}
//       <Route
//         path="/admin"
//         element={
//           <ProtectedRoute user={user} role="admin">
//             <AdminPage />
//           </ProtectedRoute>
//         }
//       />
//       <Route
//         path="/admin/adduser"
//         element={
//           <ProtectedRoute user={user} role="admin">
//             <AddUser />
//           </ProtectedRoute>
//         }
//       />
//       <Route
//         path="/admin/adddevice"
//         element={
//           <ProtectedRoute user={user} role="admin">
//             <AddDevice />
//           </ProtectedRoute>
//         }
//       />
//       <Route
//         path="/admin/addadmin"
//         element={
//           <ProtectedRoute user={user} role="admin">
//             <AddAdmin />
//           </ProtectedRoute>
//         }
//       />
//       <Route
//         path="/admin/assign-user"
//         element={
//           <ProtectedRoute user={user} role="admin">
//             <AssignUser />
//           </ProtectedRoute>
//         }
//       />
//       <Route
//         path="/admin/addpatient"
//         element={
//           <ProtectedRoute user={user} role="admin">
//             <AddPatient />
//           </ProtectedRoute>
//         }
//       />
//       <Route
//         path="/admin/assign-device"
//         element={
//           <ProtectedRoute user={user} role="admin">
//             <AssignDevice />
//           </ProtectedRoute>
//         }
//       />

//       {/* Reusing AdminPage for other admin-related views */}
//       <Route
//         path="/admin/userdetails"
//         element={
//           <ProtectedRoute user={user} role="admin">
//             <AdminPage />
//           </ProtectedRoute>
//         }
//       />
//       <Route
//         path="/admin/admindetails"
//         element={
//           <ProtectedRoute user={user} role="admin">
//             <AdminPage />
//           </ProtectedRoute>
//         }
//       />
//       <Route
//         path="/admin/devicedetails"
//         element={
//           <ProtectedRoute user={user} role="admin">
//             <AdminPage />
//           </ProtectedRoute>
//         }
//       />
//       <Route
//         path="/alerts"
//         element={
//           <ProtectedRoute user={user} role="admin">
//             <AdminPage />
//           </ProtectedRoute>
//         }
//       />

//       {/* User Dashboard */}
//       <Route
//         path="/patients"
//         element={
//           <ProtectedRoute user={user} role="user">
//             <PatientList />
//           </ProtectedRoute>
//         }
//       />

//       <Route
//         path="/dashboard/:patientId"
//         element={
//           <ProtectedRoute user={user} role="user">
//             <Dashboard />
//           </ProtectedRoute>
//         }
//       />

//       <Route
//         path="/useralerts"
//         element={
//           <ProtectedRoute user={user} role="user">
//             <AlertsPage />
//           </ProtectedRoute>
//         }
//       />

//       {/* Open Access Page (optional monitoring page) */}
//       <Route path="/patient-vitals" element={<PatientVitalsPage />} />

//       {/* Default fallback: Redirect to login */}
//       <Route path="*" element={<Navigate to="/login" />} />
//     </Routes>
//   );
// }

// export default App;

import React, { useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchAlertsByUser } from "./redux/slices/AlertSlice";
import { fetchCurrentUser } from "./redux/slices/authSlice";

// Components
import Login from "./components/Login";
import Dashboard from "./components/User/Dashboard";
import AdminPage from "./components/Admin/adminpage";
import AddUser from "./components/Admin/AddUser";
import AddDevice from "./components/Admin/AddDevice";
import AddAdmin from "./components/Admin/AddAdmin";
import AssignUser from "./components/Admin/AssignUser";
import AddPatient from "./components/Admin/AddPatient";
import AssignDevice from "./components/Admin/AssignDevice";
import PatientVitalsPage from "./components/Admin/PatientVitalsPage";
import ProtectedRoute from "./components/User/ProtectedRoute";
import AlertsPage from "./components/User/useralerts";
import PatientList from "./components/User/PatientList";
import BluetoothWiFiConnect from "./components/Admin/BluetoothWiFiConnect";

function App() {
  const { user, loading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  // Restore user on reload using token + backend fetch
  useEffect(() => {
    const token = sessionStorage.getItem("access_token");
    // Only attempt to fetch current user if token exists and no user in redux
    if (token && !user) {
      dispatch(fetchCurrentUser());
    }
    // No need for else-redirect; let ProtectedRoute handle it
  }, [dispatch, user]);

  useEffect(() => {
    if (user && user.user_id && user.role === "user") {
      dispatch(fetchAlertsByUser(user.user_id));
      const interval = setInterval(() => {
        dispatch(fetchAlertsByUser(user.user_id));
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [dispatch, user]);

  return (
    <Routes>
      {/* Login Route */}
      <Route path="/login" element={<Login />} />

      {/* Admin Protected Routes */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute user={user} loading={loading} role="admin">
            <AdminPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/adduser"
        element={
          <ProtectedRoute user={user} loading={loading} role="admin">
            <AddUser />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/adddevice"
        element={
          <ProtectedRoute user={user} loading={loading} role="admin">
            <AddDevice />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/addadmin"
        element={
          <ProtectedRoute user={user} loading={loading} role="admin">
            <AddAdmin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/assign-user"
        element={
          <ProtectedRoute user={user} loading={loading} role="admin">
            <AssignUser />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/addpatient"
        element={
          <ProtectedRoute user={user} loading={loading} role="admin">
            <AddPatient />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/assign-device"
        element={
          <ProtectedRoute user={user} loading={loading} role="admin">
            <AssignDevice />
          </ProtectedRoute>
        }
      />
      {/* Other admin detail routes */}
      <Route
        path="/admin/userdetails"
        element={
          <ProtectedRoute user={user} loading={loading} role="admin">
            <AdminPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/admindetails"
        element={
          <ProtectedRoute user={user} loading={loading} role="admin">
            <AdminPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/devicedetails"
        element={
          <ProtectedRoute user={user} loading={loading} role="admin">
            <AdminPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/alerts"
        element={
          <ProtectedRoute user={user} loading={loading} role="admin">
            <AdminPage />
          </ProtectedRoute>
        }
      />

      {/* User Dashboard */}
      <Route
        path="/patients"
        element={
          <ProtectedRoute user={user} loading={loading} role="user">
            <PatientList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/:patientId"
        element={
          <ProtectedRoute user={user} loading={loading} role="user">
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/useralerts"
        element={
          <ProtectedRoute user={user} loading={loading} role="user">
            <AlertsPage />
          </ProtectedRoute>
        }
      />

      {/* Open Access Page */}
      <Route path="/patient-vitals" element={<PatientVitalsPage />} />

      {/* Default fallback */}
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
}

export default App;



